export const AuthEndpoints = {
    login: () => '/login',
    adminLogin: () => '/admin/login',
    logout: () => '/logout',
    refresh: () => '/refresh',
    forgotPassowrd: () => '/forgot-password',
    resetPassword: () => '/reset-password',
};
